import * as Actions from '../Actions/Actions'
import { clone } from '../Utility'

const initialState = {
  isPlaylist: false,
  addToPlaylist: false,
  idToAdd: null,
  AddVideoState: {
    started: false,
    pending: false,
    success: false
  },
  loggedUserState: {
    pending: false,
    logged: false
  },
  libraryState: {
    pending: true,
    loaded: false
  },
  playlistState: {
    pending: true,
    loaded: false
  },
  volumeState: {
    volume: 1,
    isMuted: false
  },
  playlists: [],
  playList: {
    state: {
      pending: true,
      loaded: false
    },
    contents: {}
  },
  library: {},
  user: null,
  content: null,
  show: null,
  autoPlay: true,
  showsPlayedCount: 0,
  sideNavVisible: false,  
  queue: {
    index: 0,
    content: []
  }
}

const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_USER_START: {
      const newState = clone(state)
      newState.loggedUserState.pending = true
      newState.loggedUserState.logged = false
      return newState
    }
    case Actions.GET_USER_SUCCESS: {
      const { user } = action
      const newState = clone(state)
      newState.loggedUserState.pending = false
      newState.loggedUserState.logged = true
      newState.user = user
      return newState
    }
    case Actions.GET_USER_FAILURE: {
      const newState = clone(state)
      newState.loggedUserState.pending = false
      return newState
    }
    case Actions.SIGN_OUT: {
      const newState = clone(state)
      newState.user = null
      newState.loggedUserState.logged = false
      return newState
    }
    case Actions.GET_LIBRARY_START: {
      const newState = clone(state)
      newState.libraryState.pending = true
      newState.libraryState.loaded = false
      return newState
    }
    case Actions.GET_LIBRARY_FINISH: {
      const newState = clone(state)
      const { library } = action
      newState.libraryState.pending = false
      newState.libraryState.loaded = true
      newState.library = library
      return newState
    }
    case Actions.GET_PLAYLISTS_START: {
      const newState = clone(state)
      newState.playlistState.pending = true
      newState.playlistState.loaded = false
      return newState
    }
    case Actions.GET_PLAYLISTS_FINISH: {
      const newState = clone(state)
      newState.playlistState.pending = false
      newState.playlistState.loaded = true
      newState.playlists = action.playlists
      return newState
    }
    case Actions.UPDATE_HERO_IMG: {
      const newState = clone(state)
      newState.heroImg = action.url
      return newState
    }
    case Actions.CHOOSE_SHOW: {
      const newState = clone(state)
      newState.show = action.content
      return newState
    }
    case Actions.CHOOSE_HERO: {
      const newState = clone(state)
      newState.content = action.content
      return newState
    }
    case Actions.UPDATE_SETTINGS: {
      const newState = clone(state)
      newState.autoPlay = action.isAutoPlay
      return newState
    }
    case 'UPDATE_SHOW_COUNT': {
      const newState = clone(state)
      newState.showsPlayedCount++
      return newState
    }
    case 'RESET_SHOW_COUNT': {
      const newState = clone(state)
      newState.showsPlayedCount = 0
      return newState
    }
    case 'TOGGLE_SIDE_NAV': {
      const newState = clone(state)
      newState.sideNavVisible = !state.sideNavVisible
      return newState
    }
    case 'VOLUME_ADJUST': {
      const newState = clone(state)
      newState.volumeState.volume = action.volume
      return newState
    }
    case 'VOLUME_TOGGLE': {
      const newState = clone(state)
      if (action.isMuted) {
        newState.volumeState.volume = 0
        newState.volumeState.isMuted = true
        return newState
      }
      newState.volumeState.volume = 1
      newState.volumeState.isMuted = false
      return newState
    }
    case Actions.GET_PLAYLIST_START: {
      const newState = clone(state)
      newState.playList.state.pending = true
      newState.playList.state.loaded = false
      return newState
    }
    case Actions.GET_PLAYLIST_FINISH: {
      const newState = clone(state)
      newState.playList.state.pending = false
      newState.playList.state.loaded = true
      newState.playList.contents = action.res
      return newState
    }
    case 'TOGGLE_ADD_TO_PLAYLIST': {
      const newState = clone(state)
      newState.addToPlaylist = !state.addToPlaylist
      if (action.id !== undefined) {
        newState.idToAdd = action.id
        return newState
      }
      newState.idToAdd = null
      return newState
    }
    case Actions.ADD_START: {
      const newState = clone(state)
      newState.AddVideoState.started = true;
      newState.AddVideoState.pending = true;
      newState.AddVideoState.success = false;
      return newState
    }
    case Actions.ADD_SUCCESS: {
      const newState = clone(state)
      newState.AddVideoState.pending = false;
      newState.AddVideoState.success = true;
      return newState
    }
    case Actions.ADD_FAIL: {
      const newState = clone(state)
      newState.AddVideoState.pending = false;
      newState.AddVideoState.success = false;
      return newState
    }
    case 'RESET_ADD_STATE': {
      const newState = clone(state)
      newState.AddVideoState.started = false
      newState.AddVideoState.pending = false
      newState.AddVideoState.success = false
      return newState
    }
    case Actions.CREATE_QUEUE: {
      const newState = clone(state)
      console.log(action)
      // newState.queue.content = action.obj.queue
      // newState.queue.index = action.obj.index
      // console.log(newState.queue)
      return newState
    }
    case Actions.CLEAR_QUEUE: {
      const newState = clone(state) 
      newState.queue.content = []
      newState.queue.index = 0
      return newState
    }
    case Actions.ADD_TO_QUEUE: {
      const newState = clone(state)
      if (action.obj.index !== null) {
        newState.queue.index = action.obj.index
      }
      newState.queue.content = action.obj.library
      return newState
    }
    case Actions.INCREMENT_QUEUE_INDEX: {
      const newState = clone(state)
      newState.queue.index++
      return newState
    }
    case Actions.RESTART_QUEUE: {
      const newState = clone(state)
      newState.queue.index = 0
      return newState
    }
    default:
      return state
  }
}

export default mainReducer



// WEBPACK FOOTER //
// ./src/js/Reducers/mainReducer.js